// kp-slice-it-in-4 (Installments) is mandatory in US
export const isProductMandatory = (id, country, { isKlarnaOneAvailable = false }) =>
  !isKlarnaOneAvailable && id === 'kp-slice-it-in-4' && country === 'US';
